import { ids } from "@icarros/theme-react";
import styled from "styled-components";
const { size, layout } = ids || {};
const StyledButton = styled.button `
  height: ${size.general.ids_size_general_48x};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px ${layout.padding.ids_layout_padding_sm};
  gap: ${size.general.ids_size_general_4x};
  border: 0 none;
  background: none;
  cursor: pointer;
`;
export default StyledButton;
//# sourceMappingURL=Direction.style.js.map